import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=cc1715e0&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=cc1715e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1715e0",
  null
  
)

export default component.exports